import type { ReactNode } from 'react';
import { HStack } from '../Core';
import { Text } from '../Text';

interface CardRowProps {
  label: ReactNode;
  value: ReactNode;
  'data-testid'?: string;
}

/**
 * CardRow is a component that displays a row of data in a display card Stack
 * @param label - The label to display for the row.
 * @param value - The value to display for the row.
 * @param data-testid - Optional test ID for the value text element.
 */
export const CardRow = ({ label, value, 'data-testid': dataTestId }: CardRowProps) => {
  return (
    <HStack justifyContent="space-between" w="100%">
      <Text color="colors.gray.090">{label}</Text>
      <Text color="colors.gray.100" data-testid={dataTestId}>
        {value}
      </Text>
    </HStack>
  );
};
